import { i18next } from '@yola/ws-sdk';
import elementSettings from 'src/js/modules/element-settings';
import controlIds from '../constants/control-ids';
import {
  columnsOrderTargets,
  cornerTargets,
  borderTargets,
  shadowTargets,
  verticalSpacingTargets,
  horizontalGapTargets,
  horizontalSpacingTargets,
  verticalGapTargets,
} from '../constants/targets';
import settingIds from '../constants/setting-ids';
import previewGifs from '../constants/preview-gifs';
import getColorScheme from './color-scheme';
import getHorizontalContentAlignment from './horizontal-content-alignment';
import getVerticalContentAlignment from './vertical-content-alignment';

const {
  constants: { targetAttributes, targetClasses },
  helpers: { getTargetElementIds },
} = elementSettings;

const getColumnsControlSettings = (elementId) => {
  const settingId = settingIds.ALL_COLUMNS;
  const elementIds = getTargetElementIds(elementId);
  const columnElementIds = getTargetElementIds(elementId, ':scope > ws-column');

  return {
    [controlIds.COLOR_SCHEME]: getColorScheme(settingId, { elementIds: columnElementIds }),
    [controlIds.HORIZONTAL_CONTENT_ALIGNMENT]: getHorizontalContentAlignment(settingId, {
      elementIds: columnElementIds,
    }),
    [controlIds.VERTICAL_CONTENT_ALIGNMENT]: getVerticalContentAlignment(settingId, {
      elementIds: columnElementIds,
    }),
    [controlIds.COLUMNS_AMOUNT]: {
      id: controlIds.COLUMNS_AMOUNT,
      elementIds: columnElementIds,
      targets: [targetClasses.COL],
    },
    [controlIds.NO_WRAP]: {
      id: controlIds.NO_WRAP,
      glyph: 'corner-down-left',
      label: i18next.t("Columns that don't fit wrap to the next row."),
      targets: [targetAttributes.NO_WRAP],
      elementIds,
    },
    [controlIds.COLUMN_WIDTH]: {
      elementIds: columnElementIds,
      targets: [targetClasses.GROW],
    },
    [controlIds.COLUMN_HEIGHT]: {
      settingId,
      id: controlIds.COLUMN_HEIGHT,
      title: i18next.t('Column height'),
      targets: [targetAttributes.HEIGHT],
      elementIds,
      choices: [
        { name: i18next.t('Hug'), value: 'hug' },
        { name: i18next.t('Fill'), value: 'fill' },
      ],
      popover: {
        content: i18next.t('Stretch columns to match the tallest one'),
        imgSrc: previewGifs.COLUMNS_HEIGHT_GIF,
      },
    },
    [controlIds.COLUMNS_ORDER]: {
      elementIds,
      targets: columnsOrderTargets,
    },
    [controlIds.BORDER]: {
      elementIds: columnElementIds,
      targets: borderTargets,
    },
    [controlIds.SHADOW]: {
      elementIds: columnElementIds,
      targets: shadowTargets,
    },
    [controlIds.VERTICAL_SPACING]: {
      elementIds: columnElementIds,
      targets: verticalSpacingTargets,
    },
    [controlIds.HORIZONTAL_SPACING]: {
      elementIds: columnElementIds,
      targets: horizontalSpacingTargets,
    },
    [controlIds.HORIZONTAL_GAP]: {
      elementIds,
      targets: horizontalGapTargets,
    },
    [controlIds.VERTICAL_GAP]: {
      elementIds,
      targets: verticalGapTargets,
    },
    [controlIds.CORNERS]: {
      elementIds: columnElementIds,
      targets: cornerTargets,
    },
  };
};

export default getColumnsControlSettings;
